<template>
  <div id="app"><router-view /></div>
</template>

<script>
export default {
  name: 'App',
  created() {
    //检测登陆状态
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      let url = '/front/Appsto/pstatus';
      this.$request.post(url, {
        // id: window.localStorage.getItem('store_id'),
        // token: window.localStorage.getItem('token')
      }, res => {
        if (res.status == 1) {
          //登录
          window.localStorage.setItem('is_check_login', 1);
        } else {
          //未登录
          window.localStorage.setItem('is_check_login', 0);
        }
      });
    }
  }
};
</script>

<style>
html,
body {
  background: #f5f8f8;
  width: 100%;
  height: 100%;
}
/* #app {
  font-size: 0.3rem;
} */
/** 平板 **/
@media only screen and (min-width: 540px) and (max-width: 1024px) {
  #app {
    font-size: 0.3rem;
    width: 100%;
    height: auto;
  }
}
/** 平板pro **/
@media screen and (min-width: 1024px) {
  #app {
    font-size: 0.3rem;
    width: 100%;
    height: 100%;
  }
}
/** 手机 **/
@media only screen and (max-width: 540px) {
  #app {
    font-size: 0.3rem;
    width: 100%;
    height: 100%;
  }
  .login{
    width: 100%;
    height: 100%;
  }
}
/* iphone4*/
@media screen and (device-width: 320px) and (device-height: 480px) and (-webkit-device-pixel-ratio: 2){ 
  #app {
    width: 100%;
    height: auto;
  }
  .login{
    width: 100%;
    height:auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue